module.exports = __webpack_public_path__ + "img/satelliteObservation.9df6e0bd.png";